module.exports = __webpack_public_path__ + "img/musicwiz.c7afdb6f.png";